// extracted by mini-css-extract-plugin
export default {"container":"page_container__p-qiO","imgLogo":"page_imgLogo__Pfj2G","mask":"page_mask__0Jztr","content":"page_content__BRGBs"};